import { render, staticRenderFns } from "./listaTriaje.vue?vue&type=template&id=ae5ec52e&scoped=true&"
import script from "./listaTriaje.vue?vue&type=script&lang=js&"
export * from "./listaTriaje.vue?vue&type=script&lang=js&"
import style0 from "./listaTriaje.vue?vue&type=style&index=0&id=ae5ec52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5ec52e",
  null
  
)

export default component.exports